import ENV from './env';
import http from '../services/config/http';

function getAccessToken() {
  return localStorage.getItem('access_token');
}

export default {

  /**
   * Get brand Master All Category
   */
  getAllCategories() {
    return http(`${ENV.ERP_PORT}/api/v1/pre_campaigns/categories`)
    .then((response) => {

      const resultData = response.data;

      const {
        success,
        message,
        data,
      } = resultData;

      return {
        _data: data,
        _success: success,
        _message: message,
      };

    })
    .catch(error => console.log(error));
  },

  getCategoryVideoList(pageData) {

    let url = '';

    const {
      id,
      pageId,
    } = pageData;

    if (pageId) {
      url = `${ENV.ERP_PORT}/api/v1/bm/dashboard/videos?category_id=${id}&page=${pageId}`;
    } else {
      url = `${ENV.ERP_PORT}/api/v1/bm/dashboard/videos?category_id=${id}`;
    }

    return http(url, {
      params: {
        access_token: getAccessToken(),
      },
    })
    .then((response) => {

      const resultData = response.data;

      const {
        success,
        message,
        total_pages,
        data,
      } = resultData;

      return {
        data,
        _success: success,
        _message: message,
        total_pages,
      };

    })
    .catch(error => console.log(error));
  },
};



// WEBPACK FOOTER //
// ./src/services/category.js